import { useState, useEffect, useCallback } from "react";
import Footer from "../../components/shared/Footer";
import AttachExhibits from "./components/AttachExhibits";
import AttorneySelect from "../../components/shared/AttorneySelect";
import ExistingEfileSummary from "./components/ExistingEFileSummary";
import * as APIModels from "../../models";
import Coversheet from "./components/Coversheet";

import { useParams } from "react-router-dom";
import {
    SubmissionService,
    eFileService,
} from "../../services/SubmissionService";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../components/shared/modals/ErrorModal";

export default function BatchFile() {
    const { id } = useParams<{ id: string }>();

    const [eFileUpload, seteFileUpload] = useState(
        {} as APIModels.BatchUpload | undefined
    );
    const [addExhibit, setAddExhibits] = useState(false);
    const [loading, setLoading] = useState(true);

    const [showErrorModal, setShowErrorModal] = useState(false);

    const onEMClose = () => {
        setErrorProps({ errorMessage: "", onClose: onEMClose });
        setShowErrorModal(false);
    };

    const [errorProps, setErrorProps] = useState({
        errorMessage: "",
        onClose: onEMClose,
    } as ErrorModalProps);

    useEffect(() => {
        if (errorProps.errorMessage !== "") {
            console.log("show error modal:" + errorProps.errorMessage);
            setShowErrorModal(true);
        } else {
            setShowErrorModal(false);
        }
    }, [errorProps.errorMessage]);

    useEffect(() => {
        eFileService.get({ id: id }).then(
            (resp) => {
                setLoading(false);
                if (resp.successful && resp.data) {
                    //show efile success
                    seteFileUpload(resp.data);
                } else {
                    setErrorProps({
                        errorMessage: resp.errorMessage ?? "",
                        onClose: onEMClose,
                    });
                }
            },
            (error) => {
                setLoading(false);
                setErrorProps({
                    errorMessage: error.message,
                    onClose: onEMClose,
                });
            }
        );
    }, []);

    useEffect(() => {
        console.log("useEffect eFileUpload", eFileUpload);
    }, [eFileUpload]);

    const [addCoversheet, setAddCoversheet] = useState(false);

    const onAttorneySelected = (id: string, name: string) => {
        //seteFileUpload({ ...eFileUpload, attorneyID: id, attorneyName: name });
        if (eFileUpload === null) {
            seteFileUpload({ attorneyID: id, attorneyName: name });
        } else {
            seteFileUpload({
                ...eFileUpload,
                attorneyID: id,
                attorneyName: name,
            });
        }
        console.log("NEWCASE ATTORNEYID " + id);
    };

    const onFirmSelected = (_id: string, _name: string) => {
        seteFileUpload({ ...eFileUpload, attorneyID: "", attorneyName: "" });
        console.log(eFileUpload);
    };

    const onClickAddCoversheet = () => setAddCoversheet(true);
    const onClickNoCoversheet = () => setAddCoversheet(false);

    const onSubmit = () => {
        SubmissionService.uploadBatch({
            id: id,
            body: {
                ...eFileUpload,
                uploadTypeKey:
                    window.location.href.toLowerCase().indexOf("new") > 0
                        ? 4
                        : 3,
            },
        }).then(
            (resp) => {
                console.log(resp);
                if (resp.successful && resp.data) {
                    //show efile success
                    window.location.href = "/uploads";
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const onCoversheetComplete = (completeCoversheet: APIModels.Coversheet) => {
        seteFileUpload({ ...eFileUpload, coversheet: completeCoversheet });
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Batch File
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {showErrorModal && <ErrorModal {...errorProps} />}
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-8">
                                        <div
                                            id="checkout-nav-pills-wizard"
                                            className="twitter-bs-wizard form-wizard-header"
                                        >
                                            <ul className="twitter-bs-wizard-nav mb-2 nav nav-pills nav-justified">
                                                <li className="nav-item">
                                                    <a
                                                        href="#attorney-info"
                                                        className="nav-link active"
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            01
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Attorney
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a
                                                        href={
                                                            !eFileUpload?.coversheet &&
                                                            addCoversheet
                                                                ? "#"
                                                                : "#summary"
                                                        }
                                                        className={
                                                            !eFileUpload?.coversheet &&
                                                            addCoversheet
                                                                ? "nav-link disabled"
                                                                : "nav-link"
                                                        }
                                                        data-bs-toggle="tab"
                                                        data-toggle="tab"
                                                    >
                                                        <span className="number">
                                                            03
                                                        </span>
                                                        <span className="d-none d-sm-inline">
                                                            Summary
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content twitter-bs-wizard-tab-content">
                                                <div
                                                    className="tab-pane active"
                                                    id="attorney-info"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Attorney Information
                                                        </h4>
                                                        <p className="sub-header">
                                                            Please select the
                                                            attorney filing the
                                                            pleadings.
                                                        </p>
                                                    </div>
                                                    <AttorneySelect
                                                        onAttorneySelected={
                                                            onAttorneySelected
                                                        }
                                                        onFirmSelected={
                                                            onFirmSelected
                                                        }
                                                    />
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="list-inline-item">
                                                            <a
                                                                href="/uploads"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left"></i>{" "}
                                                                Back to Upload
                                                            </a>
                                                        </li>
                                                        <li className="next list-inline-item float-end">
                                                            {!eFileUpload?.attorneyID ||
                                                            eFileUpload?.attorneyID ==
                                                                "" ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success disabled"
                                                                    disabled
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div
                                                    className="tab-pane"
                                                    id="summary"
                                                >
                                                    <div>
                                                        <h4 className="header-title">
                                                            Summary
                                                        </h4>
                                                        <p className="sub-header">
                                                            Review the
                                                            information below
                                                            and verify for
                                                            accuracy.
                                                        </p>
                                                    </div>
                                                    <div>
                                                        {" "}
                                                        <ExistingEfileSummary
                                                            upload={
                                                                eFileUpload ??
                                                                {}
                                                            }
                                                        />
                                                    </div>
                                                    <ul className="pager wizard list-inline mt-2">
                                                        <li className="previous list-inline-item">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                            >
                                                                <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                Back to Exhibits
                                                            </button>
                                                        </li>

                                                        <li className="next list-inline-item float-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                onClick={
                                                                    onSubmit
                                                                }
                                                            >
                                                                Submit
                                                                <i className="mdi mdi-arrow-right"></i>{" "}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
